import { memo } from 'react';
import { Avatar, AvatarProps } from '@mui/material';
import { imageUrl } from '@dfl/mui-react-common';
import { IMedia } from 'modules/common/interfaces';

type AvatarMediaProps = AvatarProps & {
  avatar?: IMedia;
  name?: string;
  hd?: boolean;
};

const AvatarMedia = ({ avatar, name, hd, ...props }: AvatarMediaProps) => {
  const image = avatar?.type === 'video' ? undefined : avatar;
  const url = hd ? image?.url : image?.thumb;
  return <Avatar alt={name} {...props} src={imageUrl(url as string)} />;
};

export default memo(AvatarMedia);
